(function($){

    $(document).ready(function() {
            $("p:has(img) img").unwrap();

            $('.hero a[href*=https]').attr('target','_blank');

            $('.mobilebtn').on('click', function() {
                $('body > nav').addClass('on');
                $('#contact-anchor-link').hide();
            });
            
            $('body > nav > a').on('click', function(e) {
                e.preventDefault();
                $('body > nav').removeClass('on');
                $('#contact-anchor-link').show();
            });

            $('.keypoints > a').on('click', function(e) {
                $(this).toggleClass('on');
                e.preventDefault();
            });


                $('section.solutions .solutionz').owlCarousel({
                    loop:true,
                    margin: 0,
                    nav:true,
                    autoplay:true,
                    autoplayTimeout:8000,
                    autoplayHoverPause:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:1
                        },
                        1000:{
                            items:1
                        }
                    }
                })


                $('section.team ul.mobile').owlCarousel({
                    loop:true,
                    margin: 0,
                    nav:true,
                    autoplay:true,
                    autoplayTimeout:8000,
                    autoplayHoverPause:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:1
                        },
                        1000:{
                            items:1
                        }
                    }
                })

                $('section.brands.mobile').owlCarousel({
                    loop:true,
                    margin: 0,
                    nav:true,
                    autoplay:true,
                    autoplayTimeout:8000,
                    autoplayHoverPause:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:1
                        },
                        1000:{
                            items:1
                        }
                    }
                })


            $('.team li a').on('click', function(e) {
                var contenthtml=$(this).closest('li').html();

                var html='<div class="lb">' + contenthtml + '<a href="#" class="close" tabindex="1">Close</a></div>';

                $('body').prepend(html);

                setTimeout(function(){
                    $('.lb').addClass('on');
                    $('.lb .close').focus();
                }, 100);
                
                $('.close').on('click', function(e) {
                    $('.lb').removeClass('on');

                    setTimeout(function(){ 
                        $('.lb').remove();
                    }, 1000);

                    e.preventDefault();
                })

                e.preventDefault();
            })

            // BRANDING DETAIL CONTACT FORM

            //Handle Anchor Link Click
            $contactAnchorLink = $('.contact-anchor-link');
            $contactAnchorLink.on('click', function(e) {
                e.preventDefault();

                scrollTarget = $(this).attr('href');
                $('html, body').animate({ 
                    scrollTop: $(scrollTarget).offset().top
                }); 
            });

            // CONTACT US QUERY STRING

            var $contactDropdown = '#field_interested-in';
            var $query = new URLSearchParams(window.location.search);
            var $interested = $query.get('interestedin');
            if( $interested ){
                var parsedQuery = new DOMParser().parseFromString( $interested, 'text/html' );
                var parsed = parsedQuery.documentElement.textContent;
                $($contactDropdown+' option[value="'+parsed+'"]').prop('selected',true);
            }

            //Show and Hide Anchor Link
            if (document.getElementById('contact-anchor-link')) {

         
                let self = {};
                let initial = true;
                let scrolling = false;
            
                var contactBtn = document.getElementById('contact-anchor-link');
                var contactUsScroll = function(){
                    window.scrollY >= 338 ? contactBtn.classList.add('sticky') : contactBtn.classList.remove('sticky');
                    window.requestAnimationFrame( contactUsScroll );
                }
                window.requestAnimationFrame( contactUsScroll );

                //Detect Scrolling
                $(window).on('scroll', function(){
                    if(self.scrollTimeout !== 'undefined') { clearTimeout(self.scrollTimeout); }
                    $('body').addClass( 'is-scrolling' );

                    self.scrollTimeout = window.setTimeout(function() {
                        $('body').removeClass( 'is-scrolling' );
                    }, 400);
                });

        }
        //END BRANDING DETAIL CONTACT FORM
    
        $('.js-facet-mobile-accordion').on('click', function() {
            $('.mobile-accordion').slideToggle();
            $('.mobile-icon--angle').toggleClass('rotate');
        })

        // WP Facets - Hide Wrapper if no filter options exist
        document.addEventListener('facetwp-loaded', function() {
            $.each(FWP.settings.num_choices, function(key, val) {
                var $facet = $('.facetwp-facet-' + key);
                var $parent = $facet.closest('.facet-wrap');
                var $flyout = $facet.closest('.flyout-row');
                if ($parent.length || $flyout.length) {
                    var $which = $parent.length ? $parent : $flyout;
                    (0 === val) ? $which.hide() : $which.show();
                }
            });
        });

        // WP Facets - Hide Reset Button if no facets are selected
        $(document).on('facetwp-loaded', function() {
            var querystring = FWP.buildQueryString();
            if ( '' === querystring ) {
                $('.facet-reset').hide();
            }
            else {
                $('.facet-reset').show();
            }
        });

    // BRANDS VIEWER
    $('[data-brands-viewer]').each(function () {
        var $viewer = $(this);
        var $categoriesContainer = $viewer.find('.categories');
        var $categoriesList = $categoriesContainer.find('.categories--list');
        var $categories = $categoriesList.find('.categories--item');
        var $activeCategory = $categoriesList.find('.categories--item.active').first();
        var $brandsContainer = $viewer.find('.list');
        var $brands = $brandsContainer.find('.brand');

        $categories.on( 'click touchend', function () {
            var $category = $(this);
            if ($category.is($activeCategory)) {
                return;
            }

            if ($activeCategory) {
                $activeCategory.removeClass('active');
            }

            $activeCategory = $category;
            $activeCategory.addClass('active');

            var brandId = $activeCategory.data('brand');
            $brandsContainer.addClass('out');
            
            setTimeout(function () {
                $brandsContainer.removeClass('out');
                $brands.each(function () {
                    var $brand = $(this);
                    if ($brand.data('brands').includes(brandId) || brandId === 0) {
                        $brand.show();
                    } else {
                        $brand.hide();
                    }
                });
            }, 750);
        });

        function hideCategories() {
            $categoriesContainer.off('click touchend', hideCategories);
            $categoriesContainer.removeClass('open');
        }

        var $categoriesTrigger = $viewer.find('.categories--trigger');
        $categoriesTrigger.on('click touchend', function (event) {
            if ($categoriesContainer.hasClass('open')) {
                hideCategories();
            } else {
                $categoriesContainer.on('click touchend', hideCategories);
                $categoriesContainer.addClass('open');

                $(document).on('click.brands-viewer', function (event) {
                    if (!$categoriesContainer.is(event.target) && !$categoriesContainer.has(event.target).length) {
                        $(document).off('click.brands-viewer');
                        hideCategories();
                    }
                });
            }

            event.stopPropagation();
            event.preventDefault();
        });
    });

    // YOUTUBE GALLERY
    $('.youtube-gallery').each(function () {
        var $gallery = $(this);
        var $player = $gallery.find('.youtube-gallery__player');
        var $playlist = $gallery.find('.youtube-gallery__playlist');
        var $playlistItems = $playlist.find('.youtube-gallery__playlist-item');
        var $activePlaylistItem = $playlist.find('.youtube-gallery__playlist-item--active').first();

        $playlistItems.on( 'click touchend', function () {
            var $playlistItem = $(this);
            if ($playlistItem.is($activePlaylistItem)) {
                return;
            }

            if ($activePlaylistItem) {
                $activePlaylistItem.removeClass('youtube-gallery__playlist-item--active');
            }

            $activePlaylistItem = $playlistItem;
            $playlistItem.addClass('youtube-gallery__playlist-item--active');
            $player.find('iframe').attr('src', $playlistItem.data('video'));
        });
    });



    //Solutions Slider
    class SolutionsSlider {
        constructor() {
            var self = this;
            
            self.$wrapper = $('.solutions-slider .panels');
            self.$nav = $('.solutions-slider .arrows');
            self.$heading = $('.solutions-slider .header .heading');
            self.$cur = self.$wrapper.find('.owl-item.active');

            self.singleSlide = $('.solutions-slider').data('single-slide');
            self.autoplay = self.singleSlide != '' ? false : true;
            self.mouseDrag = self.mouseDrag != '' ? false : true;
            self.touchDrag = self.touchDrag != '' ? false : true;
            self.pullDrag = self.pullDrag != '' ? false : true;
            self.slideTransition = self.slideTransition != '' ? '' : 'cubic-bezier(0.65, 0, 0.35, 1)';

            if(self.singleSlide != '') {
                self.$nav.hide();
            }
            
            //Carousel
            self.carousel = self.$wrapper.owlCarousel({
                loop								: true,
                margin							:  0,
                nav									: true,
                autoplay						: self.autoplay,
                autoplayTimeout			: 8000,
                autoplayHoverPause	: true,
                navContainer				: self.$nav,
                items								: 1,
                smartSpeed					: 750,
                navSpeed            : 750,
                loop                : false,
                rewind              : true,
                slideTransition			: self.slideTransition,
                mouseDrag						: self.mouseDrag,
                touchDrag						: self.touchDrag,
                pullDrag						: self.pullDrag,
                onChange						: function(e) {
                    self.swapOut.bind(self, e)();
                },
                onChanged						: function(e) {
                    self.swapIn.bind(self, e)();
                }
            });
            self.$nav.click(function() {
                self.carousel.trigger('stop.owl.autoplay');
            });

            //Scene Interaction
            self.initScenes.bind(self)();

            if(self.singleSlide != '') {
                var _cur = self.$wrapper.find('.panel').index(self.$wrapper.find('#' + self.singleSlide));
                self.carousel.trigger('to.owl.carousel', _cur);

                self.$wrapper.addClass('static');
                self.$nav.hide();
                $('.solutions-slider').find('.header').hide();
            }
        }

        swapOut(e) {
            var self = this;

            this.$heading.fadeOut('fast');
            self.$panels.find('.button').css({opacity: 0});
        }
        swapIn(e) {
            var self = this;

            self.$panels = self.$wrapper.find('.panel');
            if(e.relatedTarget.$stage) {
                self.$cur = $(e.relatedTarget.$stage[0].childNodes[e.relatedTarget.current()]).children('.panel')

                this.$heading.promise().done(function(){
                    $(this).text( self.$cur.data('heading') ).fadeIn('fast');
                });

                setTimeout(function(){
                    TweenLite.staggerFromTo(self.$cur.find('.button'), .5, {
                        opacity		: 0,
                        borderWidth	: "1rem"
                    }, {
                        opacity		: 1,
                        borderWidth	: "0rem"
                    }, 0.25);
                }, 500);
            }
        }

        initScenes() {
            var self = this;

            class Scene {
                constructor($scene) {
                    var self = this;
                    
                    self.$wrapper = $scene;
                    self.$objects = $scene.find('.object');
                    self.$peopleEl = $scene.find('.person');
                    self.people = [];
                    self.peopleCur = 0;
                    self.$buttons = $scene.find('.button');
                    self.$details = $scene.find('.detail');
                    self.groups = [];
                    self.groupCur = null;
                    self.detailActive = false;

                    $.each(self.$buttons, function(){
                        let $button = $(this);
                        let $name = $button.data('group');

                        self.groups.push({
                            $button		: $button,
                            $objects	: self.$objects.filter(function()
                            {
                                    return ($(this).data('group') == $name);
                            }),
                            $detail		: self.$details.filter(function()
                            {
                                    return ($(this).data('group') == $name);
                            })
                        });
                    });

                    self.groups.forEach(group => {
                        $.each(group.$objects, function() {
                            let src = $(this).find('img').attr('src');
                            let activeSrc = src.split('.')[0] + '-active.png'
                            $(this).append('<div class="active-state" style="background-image:url(' + activeSrc + ');"></div>')
                        });

                        group.$button.hover(
                            function() {
                                self.activateGroup.bind(self, group)();
                            },
                            function() {
                                self.deactivateGroup.bind(self, group)();
                            }
                        );
                        group.$button.click(function(e) {
                            e.preventDefault();
                            e.stopPropagation();


                            self.showDetail.bind(self, group)();
                            self.deactivateGroup.bind(self, group)();
                            self.activateGroup.bind(self, group)();
                        });

                        group.$objects.hover(
                            function() {
                                self.activateGroup.bind(self, group)();
                            },
                            function() {
                                self.deactivateGroup.bind(self, group)();
                            }
                        );
                        group.$objects.click(function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            group.$button.click();
                        });

                        group.$detail.find('.close').click(function(e) {
                            self.closeDetail.bind(self, group)();
                            self.deactivateGroup.bind(self, group)();
                        });

                        self.$wrapper.click(function(e) {
                            if (self.detailActive) {
                                self.closeDetail.bind(self, self.groupCur)();
                                self.deactivateGroup.bind(self, self.groupCur)();
                            }
                        });
                        self.$details.click(function(e) {
                            e.stopPropagation();
                        });
                    });

                    $.each(self.$peopleEl, function(i) {
                        let $el = $(this),
                            index = $el.data('persongroup') - 1;
                            if(self.people[index]) {
                                self.people[index].push($el);
                            } else {
                                self.people[index] = [$el]
                            }
                        });
                    if(self.people.length) {
                        self.people[self.peopleCur].forEach(function($el) { $el.show() });
                        $.each(self.people[self.peopleCur], function () {
                            $(this).show();
                        });
                        
                        setInterval(function(){
                            $.each(self.people[self.peopleCur], function () {
                                $(this).fadeOut();
                            });
                            self.peopleCur = self.peopleCur == self.people.length-1 ? 0 : self.peopleCur + 1;
                            $.each(self.people[self.peopleCur], function () {
                                $(this).fadeIn();
                            });
                        }, 4000);
                    }
                }

                activateGroup(group) {
                        var self = this;

                        TweenLite.to(group.$button, .5, {
                            borderWidth	: ".5rem"
                        });
                        group.$objects.addClass('active');
                }
                deactivateGroup(group) {
                        var self = this;

                        self.groups.forEach(group => {
                            if(group != self.groupCur) {
                                TweenLite.to(group.$button, .5, {
                                    borderWidth	: "0rem"
                                });
                                group.$objects.removeClass('active');
                            }
                        });
                }

                showDetail(group) {
                    var self = this;

                    self.groupCur = group;
                    self.detailActive = true;

                    self.$buttons.fadeOut('fast', function() {
                        TweenLite.to(group.$detail, .2, {
                            alpha		: 0,
                            x			: -100,
                            display 	: 'none',
                            onComplete	: function() {

                                self.$details.fadeOut('fast', function() {
                                    TweenLite.fromTo(group.$detail, .2, {
                                        alpha	: 0,
                                        x		: 100
                                    }, {
                                        alpha	: 1,
                                        x		: 0,
                                        display	: 'block'
                                    });
                                });
                            }
                        });
                    
                    });
                }
                closeDetail(group) {
                    var self = this;
                    
                    self.groupCur = null;
                    self.detailActive = false;
                    
                    console.log(group.$detail.find('.text').text());
                    TweenLite.fromTo(group.$detail, .2, {
                        alpha		: 1,
                        x			: 0
                    }, {
                        alpha		: 0,
                        x			: -100,
                        display 	: 'none',
                        onComplete	: function() {

                            TweenLite.staggerFromTo(self.$buttons, .5, {
                                opacity		: 0,
                                borderWidth	: "1rem",
                                display		: "flex"
                            }, {
                                opacity		: 1,
                                borderWidth	: "0rem"
                            }, 0.25);
                        }
                    });
                }
            }

            $.each(self.$panels, function(){
                let $this = $(this);

                new Scene($this);
            });
        }
    }; 

    let solutionsSlider = new SolutionsSlider();
    });
})(jQuery);